import defineCustomElement from '../../define-custom-element.js';

import TpSingleSelectionList from './tp-single-selection-list.js';

defineCustomElement('tp-single-selection-list', TpSingleSelectionList);

export {
  TpSingleSelectionList
}
